export const Config = {
  base_url: 'https://marketing-slim.ridexcity.com',
};
